import React, { useState } from 'react'
import { ChangeTableKeyTemplate } from '@templates'
import { TableWithFields } from '@types'
import { config } from '../../config'
import { MainTable } from '@components'
import { DescriptiveCharts } from './DescriptiveCharts'

export const StartUp: React.FC = () => {
  const [params, SetParams] = useState<TableWithFields>({
    filters: {},
    index: config.dataSet.indexes[0].value,
    keys: [],
  })
  const [selectedColumns, setSelectedColumns] = useState<
    { value: string; type: string }[]
  >([])

  return (
    <ChangeTableKeyTemplate setParams={SetParams}>
      <MainTable
        params={params}
        setSelectedColumns={setSelectedColumns}
        selectedColumns={selectedColumns}
      />
      <DescriptiveCharts params={params} selectedColumns={selectedColumns} />
    </ChangeTableKeyTemplate>
  )
}
